import rok from './rok'
export default {
    // required: 'Pole rok modelowy jest wymagane',
    ...rok,
}